import { useMutation, useQueryClient } from '@tanstack/vue-query'
import fetchApi from '@/utils/fetchApi'

export function useDeleteApiKeyMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (keyId: string) => {
      await fetchApi({
        endpoint: `/api/keys/${encodeURIComponent(keyId)}`,
        method: 'DELETE',
      })
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['api-keys', 'list'] })
    },
  })
}
